export default __webpack_public_path__ + "static/404-4ce18fbb3486997123fa2c0106cc21ac.svg";